import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = {
  class: "text-center",
  colspan: "1"
}
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = {
  class: "text-center",
  colspan: "3"
}
const _hoisted_12 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = { class: "text-right" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "text-right" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = {
  class: "text-right",
  colspan: "5"
}
const _hoisted_24 = { class: "text-right" }
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = { class: "text-right" }
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = { class: "text-right" }
const _hoisted_30 = { class: "text-right" }
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = { class: "text-right" }
const _hoisted_34 = { class: "text-right" }
const _hoisted_35 = { class: "text-right" }
const _hoisted_36 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (!_ctx.hideOptions)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.generalLedgerDisplay,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.generalLedgerDisplay) = $event)),
                    inline: "",
                    class: "text-center",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        label: "Grand Livre",
                        value: "generalLedger"
                      }),
                      _createVNode(_component_v_radio, {
                        label: "Balance",
                        value: "balance"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_switch, {
                    modelValue: _ctx.localThirdParty,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localThirdParty) = $event)),
                    label: 'Compte Auxiliaire',
                    class: "ml-2"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_data_table, {
        "hide-default-header": _ctx.generalLedgerExpanded.length > 0,
        headers: _ctx.generalLedgerHeaders,
        items: _ctx.generalLedger,
        "items-per-page": -1,
        "hide-default-footer": "",
        class: "table"
      }, {
        item: _withCtx((props) => [
          (_openBlock(), _createElementBlock("tr", {
            style: {"background-color":"#e1e1e1"},
            key: props.item.key,
            onClick: ($event: any) => (_ctx.addRemoveGeneralLedgerExpanded(props.item))
          }, [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isGeneralLedgerExpanded(props.item)
                                ? "$fa-chevron-down"
                                : "$fa-chevron-up"), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("td", {
              colspan: "4",
              class: "text-left",
              style: _normalizeStyle(_ctx.mainColor(props.item))
            }, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.mainTitle(props.item)), 1),
              (_ctx.containsErrors(props.item))
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    color: "error",
                    class: "pl-2",
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("$fa-exclamation-triangle")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 4),
            (_ctx.isGeneralLedgerExpanded(props.item))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[3] || (_cache[3] = _createElementVNode("td", { class: "text-right" }, [
                    _createElementVNode("strong", null, "Débit")
                  ], -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("td", { class: "text-right" }, [
                    _createElementVNode("strong", null, "Crédit")
                  ], -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("td", {
                    class: "text-center",
                    colspan: "1"
                  }, [
                    _createElementVNode("strong", null, "Lettrage")
                  ], -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("td", { class: "text-right" }, [
                    _createElementVNode("strong", null, "Solde")
                  ], -1))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("td", _hoisted_3, [
                    _createElementVNode("strong", null, _toDisplayString(props.item.totalDebit != 0.0
                                    ? _ctx.newCommonFormatCurrency(props.item.totalDebit, undefined)
                                    : "-"), 1)
                  ]),
                  _createElementVNode("td", _hoisted_4, [
                    _createElementVNode("strong", null, _toDisplayString(props.item.totalCredit != 0.0
                                    ? _ctx.newCommonFormatCurrency(props.item.totalCredit, undefined)
                                    : "-"), 1)
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("td", { colspan: "1" }, null, -1)),
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("strong", null, _toDisplayString(props.item.totalDebit - props.item.totalCredit
                                    ? _ctx.newCommonFormatCurrency(
                                          props.item.totalDebit - props.item.totalCredit,
                                          undefined,
                                      )
                                    : "-"), 1)
                  ])
                ], 64))
          ], 8, _hoisted_1)),
          (_ctx.isGeneralLedgerExpanded(props.item))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.accountingTransactions, (accountingTransaction, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: props.item.key + i,
                    onClick: ($event: any) => (_ctx.openAccountingTransaction(accountingTransaction)),
                    style: _normalizeStyle(_ctx.accountingTransactionStyle(accountingTransaction))
                  }, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("accountingItem.type." + accountingTransaction.log)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(accountingTransaction.date)), 1),
                    _createElementVNode("td", null, _toDisplayString(accountingTransaction.wording), 1),
                    _createElementVNode("td", null, _toDisplayString(accountingTransaction.number), 1),
                    _createElementVNode("td", null, _toDisplayString(accountingTransaction.invoiceNumber), 1),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(accountingTransaction.debit
                                    ? _ctx.newCommonFormatCurrency(
                                          accountingTransaction.debit,
                                          undefined,
                                      )
                                    : "-"), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(accountingTransaction.credit
                                    ? _ctx.newCommonFormatCurrency(
                                          accountingTransaction.credit,
                                          undefined,
                                      )
                                    : "-"), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(accountingTransaction.lettering || ""), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(accountingTransaction.balance
                                    ? _ctx.newCommonFormatCurrency(
                                          accountingTransaction.balance,
                                          undefined,
                                      )
                                    : "-"), 1)
                  ], 12, _hoisted_6))
                }), 128)),
                _createElementVNode("tr", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("td", { colspan: "1" }, null, -1)),
                  _createElementVNode("td", _hoisted_11, [
                    (props.item.error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(props.item.error), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("td", {
                    class: "text-right",
                    colspan: "1"
                  }, [
                    _createElementVNode("strong", null, "Soldes")
                  ], -1)),
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("strong", null, _toDisplayString(props.item.totalDebit != 0.0
                                    ? _ctx.newCommonFormatCurrency(props.item.totalDebit, undefined)
                                    : "-"), 1)
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("strong", null, _toDisplayString(props.item.totalCredit != 0.0
                                    ? _ctx.newCommonFormatCurrency(props.item.totalCredit, undefined)
                                    : "-"), 1)
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("td", { colspan: "1" }, null, -1)),
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("strong", null, _toDisplayString(props.item.totalDebit - props.item.totalCredit
                                    ? _ctx.newCommonFormatCurrency(
                                          props.item.totalDebit - props.item.totalCredit,
                                          undefined,
                                      )
                                    : "-"), 1)
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        "body.append": _withCtx(() => [
          (_ctx.generalLedger.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_ctx.localThirdParty)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("tr", null, [
                        _cache[11] || (_cache[11] = _createElementVNode("td", {
                          class: "text-right",
                          colspan: "5"
                        }, "Balance", -1)),
                        _createElementVNode("td", _hoisted_16, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalDebit, undefined)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalCredit, undefined)), 1)
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("td", null, null, -1)),
                        _createElementVNode("td", {
                          class: "text-right",
                          style: _normalizeStyle(_ctx.totalBalance ? 'color:red;' : '')
                        }, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.totalBalance
                                        ? _ctx.newCommonFormatCurrency(_ctx.totalBalance, undefined)
                                        : "-"), 1)
                        ], 4)
                      ]),
                      (!_ctx.hideBodyAppend)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                            _cache[13] || (_cache[13] = _createElementVNode("td", {
                              class: "text-right",
                              colspan: "5"
                            }, "Total charges", -1)),
                            _createElementVNode("td", _hoisted_19, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.total6Debit - _ctx.total6Credit
                                        ? _ctx.newCommonFormatCurrency(_ctx.total6Debit - _ctx.total6Credit)
                                        : "-"), 1)
                            ]),
                            _cache[14] || (_cache[14] = _createElementVNode("td", { class: "text-right" }, null, -1)),
                            _cache[15] || (_cache[15] = _createElementVNode("td", null, null, -1)),
                            _cache[16] || (_cache[16] = _createElementVNode("td", { class: "text-right" }, null, -1))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.hideBodyAppend)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                            _cache[17] || (_cache[17] = _createElementVNode("td", {
                              class: "text-right",
                              colspan: "5"
                            }, "Total produits", -1)),
                            _cache[18] || (_cache[18] = _createElementVNode("td", { class: "text-right" }, null, -1)),
                            _createElementVNode("td", _hoisted_21, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.total7Credit - _ctx.total7Debit
                                        ? _ctx.newCommonFormatCurrency(_ctx.total7Credit - _ctx.total7Debit)
                                        : "-"), 1)
                            ]),
                            _cache[19] || (_cache[19] = _createElementVNode("td", null, null, -1)),
                            _cache[20] || (_cache[20] = _createElementVNode("td", { class: "text-right" }, null, -1))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.hideBodyAppend)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.profitOrLoss > 0 ? "Bénéfice" : "Perte"), 1),
                            _cache[21] || (_cache[21] = _createElementVNode("td", { class: "text-right" }, null, -1)),
                            _cache[22] || (_cache[22] = _createElementVNode("td", { class: "text-right" }, null, -1)),
                            _cache[23] || (_cache[23] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", _hoisted_24, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.profitOrLoss
                                        ? _ctx.newCommonFormatCurrency(Math.abs(_ctx.profitOrLoss))
                                        : "-"), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("tr", null, [
                        _cache[24] || (_cache[24] = _createElementVNode("td", {
                          class: "text-right",
                          colspan: "5"
                        }, "Total 401", -1)),
                        _createElementVNode("td", _hoisted_25, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total401Debit != 0.0
                                        ? _ctx.newCommonFormatCurrency(_ctx.total401Debit, undefined)
                                        : "-"), 1)
                        ]),
                        _createElementVNode("td", _hoisted_26, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total401Credit != 0.0
                                        ? _ctx.newCommonFormatCurrency(_ctx.total401Credit, undefined)
                                        : "-"), 1)
                        ]),
                        _cache[25] || (_cache[25] = _createElementVNode("td", null, null, -1)),
                        _createElementVNode("td", _hoisted_27, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total401Debit - _ctx.total401Credit
                                        ? _ctx.newCommonFormatCurrency(
                                              _ctx.total401Debit - _ctx.total401Credit,
                                              undefined,
                                          )
                                        : "-"), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[26] || (_cache[26] = _createElementVNode("td", {
                          class: "text-right",
                          colspan: "5"
                        }, "Total 411", -1)),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total411Debit != 0.0
                                        ? _ctx.newCommonFormatCurrency(_ctx.total411Debit, undefined)
                                        : "-"), 1)
                        ]),
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total411Credit != 0.0
                                        ? _ctx.newCommonFormatCurrency(_ctx.total411Credit, undefined)
                                        : "-"), 1)
                        ]),
                        _cache[27] || (_cache[27] = _createElementVNode("td", null, null, -1)),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total411Debit - _ctx.total411Credit
                                        ? _ctx.newCommonFormatCurrency(
                                              _ctx.total411Debit - _ctx.total411Credit,
                                              undefined,
                                          )
                                        : "-"), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[28] || (_cache[28] = _createElementVNode("td", {
                          class: "text-right",
                          colspan: "5"
                        }, "Total 42", -1)),
                        _createElementVNode("td", _hoisted_31, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total42Debit != 0.0
                                        ? _ctx.newCommonFormatCurrency(_ctx.total42Debit, undefined)
                                        : "-"), 1)
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total42Credit != 0.0
                                        ? _ctx.newCommonFormatCurrency(_ctx.total42Credit, undefined)
                                        : "-"), 1)
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("td", null, null, -1)),
                        _createElementVNode("td", _hoisted_33, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total42Debit - _ctx.total42Credit
                                        ? _ctx.newCommonFormatCurrency(
                                              _ctx.total42Debit - _ctx.total42Credit,
                                              undefined,
                                          )
                                        : "-"), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[30] || (_cache[30] = _createElementVNode("td", {
                          class: "text-right",
                          colspan: "5"
                        }, "Total 512", -1)),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total512Debit != 0.0
                                        ? _ctx.newCommonFormatCurrency(_ctx.total512Debit, undefined)
                                        : "-"), 1)
                        ]),
                        _createElementVNode("td", _hoisted_35, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total512Credit != 0.0
                                        ? _ctx.newCommonFormatCurrency(_ctx.total512Credit, undefined)
                                        : "-"), 1)
                        ]),
                        _cache[31] || (_cache[31] = _createElementVNode("td", null, null, -1)),
                        _createElementVNode("td", _hoisted_36, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.total512Debit - _ctx.total512Credit
                                        ? _ctx.newCommonFormatCurrency(
                                              _ctx.total512Debit - _ctx.total512Credit,
                                              undefined,
                                          )
                                        : "-"), 1)
                        ])
                      ])
                    ], 64))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["hide-default-header", "headers", "items"])
    ]),
    _: 1
  }))
}